import { ChevronDown, ChevronRight } from "lucide-react";

const navigation = [
  {
    title: "Getting Started",
    id: "getting-started",
    items: [
      { title: "Introduction", id: "introduction" },
    ],
  },
  {
    title: "API Reference",
    id: "api",
    items: [
      { title: "Send Messages", id: "messages" },
      { title: "Getting All Groups", id: "get-all-groups" },
      { title: "Getting Group Details", id: "get-group-details" },
    ],
  },
];

const Navigation = ({
  expandedSections,
  toggleSection,
  activeSection,
  setActiveSection,
}) => (
  <div className="space-y-2 text-gray-900">
    {navigation.map((section) => (
      <div key={section.id}>
        <button
          onClick={() => toggleSection(section.id)}
          className="flex items-center justify-between p-2 text-left rounded-lg transition
                     text-gray-700 hover:text-gray-900 hover:bg-gray-100"
          type="button"
          aria-expanded={expandedSections.includes(section.id)}
          aria-controls={`section-${section.id}`}
        >
          <span className="font-medium">{section.title}</span>
          <span className="flex items-center justify-center w-6 h-6">
            {expandedSections.includes(section.id) ? (
              <ChevronDown className="w-5 h-5 text-gray-600" />
            ) : (
              <ChevronRight className="w-5 h-5 text-gray-600" />
            )}
          </span>
        </button>

        {expandedSections.includes(section.id) && (
          <div id={`section-${section.id}`} className="ml-4 mt-2 space-y-1">
            {section.items.map((item) => (
              <button
                type="button"
                key={item.id}
                onClick={() => setActiveSection(item.id)}
                className={`block w-full text-left p-2 text-sm rounded-md transition
                  ${
                    activeSection === item.id
                      ? "bg-[#01CC54]/10 border border-[#01CC54]/30 text-[#01CC54] font-medium"
                      : "text-gray-600 hover:text-gray-900 hover:bg-gray-100 border border-transparent"
                  }`}
                aria-current={activeSection === item.id ? "page" : undefined}
              >
                {item.title}
              </button>
            ))}
          </div>
        )}
      </div>
    ))}
  </div>
);

export default Navigation;
